export enum PaymentRejectType {
  /** Неверные банковские реквизиты */
  INVALID_BANK_DETAILS = 'invalid_bank_details',

  /** Подозрительная активность */
  SUSPICIOUS_ACTIVITY = 'suspicious_activity',

  /** Другое */
  OTHER = 'other',
}
